import request from '@/utils/request'

export function getSettings() {
  return request({
    url: '/api/settings',
    method: 'get'
  })
}

export function getCurrencies(params) {
  return request({
    url: '/api/currencies',
    method: 'get',
    params
  })
}

export function getProperties(params) {
  return request({
    url: '/api/properties',
    method: 'get',
    params
  })
}

export function uploadFile(file) {
  let formData = new FormData();
  formData.append("file", file);
  return new request({
    url: '/api/files',
    data: formData,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getShops(params) {
  return new request({
    url: '/api/shops',
    method: 'get'
  })
}


export function getStatuses() {
  return request({
    url: '/api/statuses',
    method: 'get'
  })
}

export function loadProductsTree(params) {
  params = {...params, 'multysearch[status.statusId]': '1,2'}
  return request({
    url: 'api/product_categories',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/global.js